import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { makeCRMApi } from "../CrmApi";
import { AxiosError, AxiosResponse } from "axios";
import { IDirectorySearchResponse, IDirectoryEntrySimpleSearchResult, ECrmDirectoryEntryType, ECrmDirectoryListSortableKey, IFilterFullSearch } from "../types/DirectoryEntry";
import { IPage } from "services/BackendApi";
import { ESortOrder } from "store/common/types";

export interface IUseCrmSearchDirectoryEntriesFullSearchParams {
  filter: IFilterFullSearch;
  pagination: IPage;
}

export const useCrmSearchDirectoryEntriesFullSearch = (params: IUseCrmSearchDirectoryEntriesFullSearchParams) => {
  const crmApi = makeCRMApi();
  
  const crmDirectoryEntries = useQuery<AxiosResponse<IDirectorySearchResponse>, AxiosError>({
    queryKey: ['crm-directory-entries-full-search', params.filter.term, params.filter.companyTypeCodes, params.pagination.limit, params.pagination.offset],
    placeholderData: keepPreviousData,
    queryFn: () =>
      crmApi.postDirectorySearch({
        filter: params.filter,
        sort: {
          key: ECrmDirectoryListSortableKey.NAME,
          order: ESortOrder.ASC,
        },
        pagination: params.pagination
      }),
  });

  // Transform IDirectoryEntrySearchResult[] to IDirectoryEntrySimpleSearchResult[]
  const transformedResults: IDirectoryEntrySimpleSearchResult[] = params.filter.term.length >= 3 
    ? (crmDirectoryEntries.data?.data?.list ?? []).map(result => ({
        id: result.id,
        directoryEntryType: ECrmDirectoryEntryType.COMPANY,
        name: result.name,
        email: result.email,
        beHumanReadableId: result.beHumanReadableId,
      }))
    : [];
  
  return { 
    directoryEntries: transformedResults,
    crmDirectoryEntries,
  };
}